import { render } from "./ProjectDropdown.vue?vue&type=template&id=64364e48"
import script from "./ProjectDropdown.vue?vue&type=script&lang=js"
export * from "./ProjectDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__